import { motion } from 'framer-motion';

import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Collapse from '@mui/material/Collapse';

import ArrowOutwardTwoToneIcon from '@mui/icons-material/ArrowOutwardTwoTone';
import { useEffect, useState } from 'react';

import { imageExist }  from '../../../assets/js/init';
import { AnimatedText } from '../../../assets/component/initComponent';
import useInView from '../../../hooks/useInView';

const Help = ({ viewOnce = true }) => {

	const [activeQuestion, setActiveQuestion] = useState(6);

	//InView Hook
	const [sectionRef, inView] = useInView();

	const handleClickQuestion = (proVal) => {
		setActiveQuestion(proVal);
	};

	//Effect
	useEffect(() => { //Get Count is in view
		if (inView) {
			if (activeQuestion === 6) {
				setTimeout(() => {
					setActiveQuestion(0);
				}, 1000);
			}
		}
	}, [inView, activeQuestion]);

	//Animation
	const mobVariant = {
		hidden: {
			opacity: 0,
			x: -140
			// scale: 0.5
		},
		visible: {
			opacity: 1,
			x: 0,
			transition: {
				delay: 0.5,
				duration: 1,
				ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
			}
		}
	};

	const answers = [
		{
			question: 'How accurate are the calculations?',
			ans: 'We use the standard math and formulae used by banks and professionals, so you can trust every number you see.'
		},
		{
			question: 'Can I view reports and charts?',
			ans: "Yes, every calculation automatically creates easy-to-read charts and tables so you can see your money's progress visually."
		},
		{
			question: 'Can I change my numbers?',
			ans: 'You can tweak your numbers as you like to see how even small changes affect your final goal.'
		},
		{
			question: 'Is my personal data safe?',
			ans: "Everything happens right on your phone. We don't store your info on any servers, and we never track your data."
		}
	];
	// const answers = [
	// 	{
	// 		question: 'How do I use the calculators?',
	// 		ans: 'Select a calculator from the categories, enter the required financial details, and tap calculate. The app instantly displays results, reports, and charts for better understanding.'
	// 	},
	// 	{
	// 		question: 'How accurate are the calculations?',
	// 		ans: 'Select a calculator from the categories, enter the required financial details, and tap calculate. The app instantly displays results, reports, and charts for better understanding.'
	// 	},
	// 	{
	// 		question: 'Can I view reports and charts?',
	// 		ans: 'Select a calculator from the categories, enter the required financial details, and tap calculate. The app instantly displays results, reports, and charts for better understanding.'
	// 	},
	// 	{
	// 		question: 'Can I reset or modify values?',
	// 		ans: 'Select a calculator from the categories, enter the required financial details, and tap calculate. The app instantly displays results, reports, and charts for better understanding.'
	// 	}
	// ];

	return(
		<Container className='containerFull' sx={{ position: 'relative' }}>
			<Box className='randObjCircle'>
				{imageExist({
					required: '/common/objects',
					url: '/circle.svg',
					alt: 'screenshot',
					height: '100%',
					width: '100%',
					style: { objectFit: 'contain' }
				})}
			</Box>
			<Grid container sx={{ position: 'relative', zIndex: 1 }} spacing={6} rowSpacing={3}>
				<Grid size={{ md: 6, xs: 12 }}>
					<Grid container spacing={4}>
						<Grid size={12}>
							<Box className='titleWithBgWt mb10' sx={{ backgroundPosition: 'left' }}>
								<Typography variant='h2' className='font25'>Need help?</Typography>
							</Box>
							<AnimatedText title='Common Questions & <br/>Respective Answers' className='font40 fontBolder whiteCl' delay={true}/>
							{/* <Typography className='font40 fontBolder'>
								Common Questions & <br/> Respective Answers
							</Typography> */}
						</Grid>
						<Grid size={12} ref={sectionRef}>
							<Grid container spacing={4}>
								{answers.map((list, index) => {
									const active = activeQuestion === index;
									return(
										<Grid size={12} key={index}>
											<Stack direction='row' spacing={2} alignItems='center' onMouseEnter={() => handleClickQuestion(index)} className='mb5' sx={{ cursor: 'pointer' }}>
												<ArrowOutwardTwoToneIcon className={`font25 ${!active && 'questionArrow' }`} style={{ color: '#BEF053' }} />
												<Typography className='font25' color={active && '#BEF053'}>{list.question}</Typography>
											</Stack>
											<Collapse in={activeQuestion === index}>
												<Box sx={{ bgcolor: '#fff', borderRadius: '15px' }} p={3} className='textCl'>
													<Typography className='font18'>{list.ans}</Typography>
												</Box>
											</Collapse>
										</Grid>
									);
								})}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={{ md: 6, xs: 12 }}>
					<motion.div
						variants={mobVariant}
						initial='hidden'
						whileInView='visible'
						viewport={{ once: viewOnce, margin: '-100px' }}
					>
						{imageExist({
							required: '/help',
							url: '/screenshots.png',
							alt: 'screenshot',
							height: '100%',
							width: '100%',
							style: { objectFit: 'contain' }
						})}
					</motion.div>
				</Grid>
			</Grid>
		</Container>
	);
};

export default Help;
